import { materialStateEnum } from '../enums';

export const materialStateEnumColors: Record<number, string> = {
    [materialStateEnum.NEW]: 'lightgreen',
    [materialStateEnum.PRESENT]: 'lightgrey',
    [materialStateEnum.REMOVE]: 'rgb(255,200,100)',
};

export const getMaterialStateColor = (state?: number): string => {
    return state !== undefined ? (materialStateEnumColors[state] ?? '') : '';
};
